import { createUrl } from './create-url';

const Sites = {
    dacia: 'https://www.daciaforsakring.se/hantering-av-personuppgifter',
    polestar: 'https://www.polestarinsurance.se/hantering-av-personuppgifter',
    renault: 'https://www.renaultforsakring.se/hantering-av-personuppgifter',
    volvia: 'https://www.volvia.se/hantering-av-personuppgifter',
};

export const getMobilityPersonalDataPage = (url: string): string => {
    const page = createUrl(url);
    if (!page) return '';

    const hostname = page.hostname;

    for (const key of Object.keys(Sites)) {
        if (hostname.includes(key)) {
            return Sites[key];
        }
    }

    return 'https://www.if.se/om-webbplatsen/hantering-av-personuppgifter';
};
